import publicRoutes from './publicRoutes';
import privateRoutes from './privateRoutes';
import onboardingRoutes from './onboardingRoutes';
import NotFound from '../pages/NotFound/Index';
import adminRoutes from './adminRoutes';

const useRoutes = () => {
    return [
        onboardingRoutes,
        publicRoutes,
        privateRoutes,
        adminRoutes,
        { path: '*', element: <NotFound /> }, // Catch-all route
    ].flat();
};

export default useRoutes;
